import { useAppCtxSelector, useAppStateMatches } from '@/core';
import { useEffect } from 'react';
import { showIntercept } from '@/core/utils/intercepts';
import ProfileForm from '../components/profile-form/profile-form';

export const useInterceptProfileIncomplete = () => {
  const hasUserAndSite = useAppStateMatches(
    'usersAndSite.siteLoaded.loggedInUser.allInfo',
  );
  const siteId = useAppCtxSelector((ctx) => ctx.site?.meta?.siteId);
  const user = useAppCtxSelector((ctx) => ctx.user);

  useEffect(() => {
    if (!hasUserAndSite) return;
    if (!user?.membershipSiteIds?.includes(siteId)) return;
    /**
     * If the user has a responsibility and a display name, their profile is complete
     * and we don't need to show the intercept
     */
    if (user?.info?.responsibilityId && user?.info?.displayName) return;

    showIntercept({
      type: 'profileIncompleteIntercept',
      content: {
        title: 'Let’s Get Your Profile Set Up',
        subtitle:
          'Before you dive in, take a minute to fill out your profile. This helps your team know who you are and makes collaboration smoother.',
        body: <ProfileForm />,
        size: 'wide',
      },
    });
  }, [hasUserAndSite, siteId, user]);
};
